import { contactFormStyles } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

Object.assign(contactFormStyles, {
    ...contactFormStyles,
    submitButton: {
        css: css`
            float: right;
            margin-top: 20px;
            min-width: 110px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
});
